export const SIDES_OF_PLACEMENT_NAME = 'Sides of placement';
